<template>
  <router-link tag="li" class="nav-item nav-dropdown" :to="url" disabled>
    <div class="nav-link nav-dropdown-toggle" @click="(e) => handleClick(e, goUrl, urlPath)">
      <i :class="classIcon"><font-awesome-icon v-if="icon" :icon="icon" /></i>
      {{$t(`nav.${name}`)}}
    </div>
    <ul class="nav-dropdown-items">
      <slot></slot>
    </ul>
  </router-link>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    goUrl: {
      required: false
    },
    urlPath: {
      required: false
    }
  },
  computed: {
    classIcon () {
      return [
        'nav-icon'
      ]
    }
  },
  methods: {
    handleClick (e, goUrl, urlPath) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
      for (let i in this.getNextSiblings(e.target.parentElement)) {
        this.getNextSiblings(e.target.parentElement)[i].classList.remove('open')
      }
      // if (goUrl && urlPath) {
      //   this.$router.push(urlPath)
      // }
    },
    getNextSiblings (elem) {
      // console.log(elem)
      let siblings = [];
      let sibling = elem.parentNode.firstChild;
      while (sibling) {
        if (sibling.nodeType === 1 && sibling !== elem) {
          siblings.push(sibling);
        }
        sibling = sibling.nextSibling
      }
      return siblings;
    }
  }
}
</script>

<style scoped lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
